import styles from './InspectorField.module.css'

export function InspectorField({
  label,
  htmlFor,
  state = 'default',
  stateLabel,
  actions,
  children,
  className = '',
  ...props
}) {
  return (
    <div
      className={[styles.root, className].filter(Boolean).join(' ')}
      data-state={state}
      {...props}
    >
      <div className={styles.identity}>
        <label htmlFor={htmlFor} className={styles.label}>{label}</label>
        {stateLabel ? <span className={styles.state}>{stateLabel}</span> : null}
      </div>
      <div className={styles.control}>{children}</div>
      {actions ? <div className={styles.actions}>{actions}</div> : <span aria-hidden="true" />}
    </div>
  )
}

export default InspectorField
